import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/metricas`;

// En metricasService.js - CREAR o ACTUALIZAR
export async function obtenerMetricasParticipantes(userInfo = {}, filtros = {}) {
  const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;

  const queryParams = {
    search: filtros.searchTerm || '',
    estado: filtros.filterEstado !== "todos" ? filtros.filterEstado : undefined,
    municipioId: filtros.filterMunicipio !== "todos" ? parseInt(filtros.filterMunicipio) : undefined,
    departamentoId: filtros.filterDepartamento !== "todos" ? parseInt(filtros.filterDepartamento) : undefined,
    genero: filtros.filterSexo !== "todos" ? filtros.filterSexo : undefined,
    promotoresId: filtros.promotoresId || undefined 
  };
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
      delete queryParams[key];
    }
  });

  const response = await axios.get(`${baseUrl}`, {
    params: queryParams,
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip,
      "x-usuario-municipio-id": usuarioMunicipioId,
      "x-usuario-es-admin": esAdmin?.toString() || "false"
    }
  });

  return response.data;
}
